<template>
  <div id="claim-report-add">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <common-text-large text="新規事故報告" class="mb-4" />
        <div class="vx-card p-8 h-full">
          <div class="content-between">
            <common-text-medium class="mb-8" text="事故概要" />
            <common-text-box-small
              title="保険契約者名"
              :required="true"
              class="mb-8"
              ref="PolicyHolder"
              :name="'PolicyHolder'"
              :showTitle="true"
            />
            <common-select-box-small
              title="船舶名"
              :required="true"
              class="mb-8"
              :options="vessels"
              ref="VesselName"
              :name="'vesselName'"
              :showTitle="true"
            />
            <common-select-box-small
              title="事故種類"
              :required="true"
              class="mb-8"
              ref="AccidentType"
              :options="accidents"
              :name="'AccidentType'"
              :showTitle="true"
            />
            <text-box-date
              class="mb-8"
              title="事故日"
              ref="AccidentDate"
              :showTitle="true"
              :maxDate="accidentDateMaxDate"
            ></text-box-date>
            <text-box-time
              class="mb-8"
              title="事故発生時間 ※時間は現時点でお分かりになる概算時刻で問題ございません。後程修正することも可能です。"
              ref="AccidentTime"
              :name="'AccidentTime'"
              :showTitle="true"
            ></text-box-time>
            <common-text-box-small
              title="事故場所"
              :required="true"
              class="mb-8"
              ref="AccidentPlace"
              :name="'AccidentPlace'"
              :showTitle="true"
            />
            <common-text-box-large
              title="事故概要"
              :required="true"
              class="mb-8"
              ref="AccidentSummary"
              :name="'AccidentSummary'"
              :showTitle="true"
            />
            <common-text-box-large
              title="損害状況"
              :required="true"
              class="mb-8"
              ref="DamageSituation"
              :name="'DamageSituation'"
              :showTitle="true"
            />
            <common-radio-button-box
              title="自航可否"
              :required="true"
              :options="selfPropelled"
              ref="SelfProprlied"
              :showTitle="true"
            />
            <common-input-file
              title="写真"
              ref="Pictures"
              :showTitle="true"
            ></common-input-file>
            <vs-divider class="my-8"></vs-divider>
            <div class="flex items-center mb-8">
              <common-text-medium class="mr-6" text="フリー項目" />
              <div class="free-annotation-text">
                ※上の項目以外で必要な情報や添付ファイルがあれば、ここに入力してください。
              </div>
            </div>
            <common-text-box-large
              title="フリー記入"
              :required="false"
              class="mb-8"
              ref="FreeMessage"
              :showTitle="true"
            />
            <common-input-file
              title="その他の添付ファイル"
              ref="FreeFiles"
              :required="false"
              :showTitle="true"
            ></common-input-file>
            <vs-divider class="my-8"></vs-divider>
            <common-text-medium class="mb-8" text="船主担当者情報" />
            <contact-info ref="ContactInfo" :showHeader="false"></contact-info>
            <div v-for="(item, index) in addContacts" :key="index">
              <contact-info ref="AddContactInfo"></contact-info>
            </div>
            <div class="flex justify-center">
              <common-add-button
                :click="addContactInfo"
                title="担当者情報追加"
                icon="PlusIcon"
              ></common-add-button>
            </div>
            <vs-divider class="my-8"></vs-divider>
            <!-- button -->
            <div class="flex justify-center">
              <common-button
                title="キャンセル"
                type="border"
                :color="AISEA_COLOR.GRAY"
                class="w-64 mr-4"
                :click="clickCancel"
              ></common-button>
              <common-button
                title="確認画面"
                class="w-64"
                :click="clickConfirm"
              ></common-button>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <hull-navigation-select
          class="mb-4"
          menuButtonLabel="メニュー"
          :menuItemOptions="getMenuItemOptions(this.$route.name)"
        >
        </hull-navigation-select>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { HULL_INSURANCE_ACCIDENT_TYPE, HULL_INSURANCE_SELF_PROPELLED, HULL_INSURANCE_CONTACT_INFO } from "@/config/const";
import { ColorMixin, HullInsranceMixin } from "@/mixins";

import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState, mapActions } = createNamespacedHelpers("hullInsuranceAddReport");

import CommonTextLarge from "../components/atoms/CommonTextLarge.vue";
import CommonTextMedium from "../components/atoms/CommonTextMedium.vue";
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import CommonSelectBoxSmall from "../components/molecules/CommonSelectBoxSmall.vue";
import CommonTextBoxSmall from "../components/molecules/CommonTextBoxSmall.vue";
import CommonTextBoxLarge from "../components/molecules/CommonTextBoxLarge.vue";
import TextBoxDate from "../components/molecules/TextBoxDate.vue";
import TextBoxTime from "../components/molecules/TextBoxTime.vue";
import CommonRadioButtonBox from "../components/molecules/CommonRadioButtonBox.vue";
import CommonInputFile from "../components/molecules/CommonInputFile.vue";
import ContactInfo from "../components/organisms/ContactInfo.vue";
import CommonButton from '../components/molecules/CommonButton.vue';
import CommonAddButton from '../components/molecules/CommonAddButton.vue';

import AuthService from "@/services/authService";

import moment from "moment";



export default {
  name: "T.ClaimReportAdd",
  mixins: [ColorMixin, HullInsranceMixin],
  components: {
    CommonTextLarge,
    CommonTextMedium,
    HullNavigationSelect,
    CommonSelectBoxSmall,
    CommonTextBoxSmall,
    CommonTextBoxLarge,
    TextBoxDate,
    TextBoxTime,
    CommonRadioButtonBox,
    CommonInputFile,
    ContactInfo,
    CommonButton,
    // eslint-disable-next-line vue/no-unused-components
    CommonAddButton
  },
  data() {
    return {
      addContacts: [],
      contactId: 1, // 関係者情報削除時に判別するためのid
      values: {},
    };
  },
  computed: {
    ...mapState(["inputValue", "vessels", "pictures", "freeFiles"]),
    accidents() {
      const _accidents = [];
      for (const key in HULL_INSURANCE_ACCIDENT_TYPE) {
        _accidents.push(HULL_INSURANCE_ACCIDENT_TYPE[key]);
      }
      return _accidents;
    },
    selfPropelled() {
      return HULL_INSURANCE_SELF_PROPELLED;
    },
    accidentDateMaxDate() {
      return moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    ...mapMutations(["SET_INPUT_VALUE", "SET_PICTURES", "SET_FREE_FILES"]),
    ...mapActions(["getVessels"]),
    getVessel(id) {
      return this.vessels.find(item => item.vessel_id === id);
    },
    getDepartment(id) {
      return HULL_INSURANCE_CONTACT_INFO.find(item => item.id === id);
    },
    addContactInfo() {
      const contact = {
        contactId: this.contactId,
      };
      this.addContacts.push(contact);
      this.contactId = this.contactId + 1;
    },

    getStaffs() {
      if (!this.$refs.AddContactInfo) return [];
      return this.$refs.AddContactInfo.filter(item => !item.disabled);
    },


    setStaffs() {
      const staffs = [];

      const defaultStaff = {
        company_name: this.$refs.ContactInfo.$refs.CompanyName.inputValue,
        contact_info: {
          name: this.$refs.ContactInfo.$refs.Name.inputValue,
          name_kana: this.$refs.ContactInfo.$refs.NameKana.inputValue,
          tel: this.$refs.ContactInfo.$refs.Telephone.inputValue,
          email: this.$refs.ContactInfo.$refs.MailAddress.inputValue,
        },
        department: this.$refs.ContactInfo.$refs.Department.inputValue.id,
      };

      staffs.push(defaultStaff);

      if (this.getStaffs().length === 0) {
        return staffs;
      }
      this.getStaffs().forEach(item => {
        const _staff = {
          company_name: item.$refs.CompanyName.inputValue,
          contact_info: {
            name: item.$refs.Name.inputValue,
            name_kana: item.$refs.NameKana.inputValue,
            tel: item.$refs.Telephone.inputValue,
            email: item.$refs.MailAddress.inputValue,
          },
          department: item.$refs.Department.inputValue.id

        }

        staffs.push(_staff);
      });

      return staffs;
    },

    validate(ref) {
      if (!ref.inputValue) {
        ref.error = true;
        return false;
      }
      ref.error = false;
      return true;
    },

    validateAll() {
      let validate = true;

      const validateRef = [
        this.$refs.VesselName,
        this.$refs.AccidentType,
        this.$refs.AccidentPlace,
        this.$refs.AccidentSummary,
        this.$refs.DamageSituation,
        this.$refs.SelfProprlied,
        this.$refs.ContactInfo.$refs.CompanyName,
        this.$refs.ContactInfo.$refs.Name,
        this.$refs.ContactInfo.$refs.NameKana,
        this.$refs.ContactInfo.$refs.Department,
      ];

      const validateTelephone = this.$refs.ContactInfo.validateTelephone(this.$refs.ContactInfo.$refs.Telephone.inputValue);
      if (!validateTelephone) {
        validate = false;
      }

      const validateMail = this.$refs.ContactInfo.validateMail(this.$refs.ContactInfo.$refs.MailAddress.inputValue);
      if (!validateMail) {
        validate = false;
      }


      this.getStaffs().forEach(item => {
        validateRef.push(item.$refs.CompanyName);
        validateRef.push(item.$refs.Department);
        validateRef.push(item.$refs.Name);
        validateRef.push(item.$refs.NameKana);

        const _validateTelephone = item.validateTelephone(item.$refs.Telephone.inputValue);
        if (!_validateTelephone) {
          validate = false;
        }

        const _validateMail = item.validateMail(item.$refs.MailAddress.inputValue);
        if (!_validateMail) {
          validate = false;
        }

      });


      validateRef.forEach(item => {
        const res = this.validate(item);
        if (!res) {
          validate = false;
        }
      });

      return validate;
    },

    setValues() {
      this.values = {
        overview: {
          policyholder: this.$refs.PolicyHolder.inputValue,
          vessel_id: this.$refs.VesselName.inputValue.vessel_id,
          accident_type: this.$refs.AccidentType.inputValue.value,
          accident_date: this.$refs.AccidentDate.inputValue ? moment(this.$refs.AccidentDate.inputValue).format("YYYY-MM-DD") : "",
          accident_time: this.$refs.AccidentTime.inputValue,
          accident_place: this.$refs.AccidentPlace.inputValue,
          accident_summary: this.$refs.AccidentSummary.inputValue,
          damage_situation: this.$refs.DamageSituation.inputValue,
          self_propelled: this.$refs.SelfProprlied.inputValue,
          free_message: this.$refs.FreeMessage.inputValue,
        },
        staff: this.setStaffs(),
      };

      this.SET_PICTURES(this.$refs.Pictures.files)
      this.SET_FREE_FILES(this.$refs.FreeFiles.files)
    },


    notifyError() {
      this.$vs.notify({
        title: "必須項目を全て入力してください。",
        text: "必須項目が全て入力されない限り登録ボタンはクリックできません。",
        color: "danger",
        position: "top-center",
      });
    },

    inputOverView() {
      this.$refs.PolicyHolder.inputValue = this.inputValue.overview.policyholder;
      this.$refs.VesselName.inputValue = this.getVessel(this.inputValue.overview.vessel_id);
      this.$refs.AccidentType.inputValue = HULL_INSURANCE_ACCIDENT_TYPE[this.inputValue.overview.accident_type];
      this.$refs.AccidentDate.inputValue = moment(this.inputValue.overview.accident_date).format("YYYY/MM/DD");
      this.$refs.AccidentTime.inputValue = this.inputValue.overview.accident_time;
      this.$refs.AccidentPlace.inputValue = this.inputValue.overview.accident_place;
      this.$refs.AccidentSummary.inputValue = this.inputValue.overview.accident_summary;
      this.$refs.DamageSituation.inputValue = this.inputValue.overview.damage_situation;
      this.$refs.SelfProprlied.inputValue = this.inputValue.overview.self_propelled;
      this.$refs.Pictures.files = this.pictures;
      this.$refs.FreeMessage.inputValue = this.inputValue.overview.free_message;
      this.$refs.FreeFiles.files = this.freeFiles;

    },
    inputStaffs() {
      this.$refs.ContactInfo.$refs.CompanyName.inputValue = this.inputValue.staff[0].company_name;
      this.$refs.ContactInfo.$refs.Name.inputValue = this.inputValue.staff[0].contact_info.name;
      this.$refs.ContactInfo.$refs.NameKana.inputValue = this.inputValue.staff[0].contact_info.name_kana;
      this.$refs.ContactInfo.$refs.Telephone.inputValue = this.inputValue.staff[0].contact_info.tel;
      this.$refs.ContactInfo.$refs.MailAddress.inputValue = this.inputValue.staff[0].contact_info.email;
      this.$refs.ContactInfo.$refs.Department.inputValue = this.getDepartment(this.inputValue.staff[0].department);


      this.getStaffs().forEach((item, index) => {
        item.$refs.CompanyName.inputValue = this.inputValue.staff[index + 1].company_name;
        item.$refs.Name.inputValue = this.inputValue.staff[index + 1].contact_info.name;
        item.$refs.NameKana.inputValue = this.inputValue.staff[index + 1].contact_info.name_kana;
        item.$refs.Telephone.inputValue = this.inputValue.staff[index + 1].contact_info.tel;
        item.$refs.MailAddress.inputValue = this.inputValue.staff[index + 1].contact_info.email;
        item.$refs.Department.inputValue = this.getDepartment(this.inputValue.staff[index + 1].department);
      });



    },

    setInputValue() {
      this.inputOverView();
      this.inputStaffs();
    },

    clickCancel() {
      this.SET_INPUT_VALUE({});

      this.$router.push({
        name: "hull-insurance-claim-report-list",
      });
    },
    clickConfirm() {
      if (!this.validateAll()) {
        this.notifyError();
        return;
      }
      this.setValues();

      this.SET_INPUT_VALUE(this.values);

      this.$router.push({
        name: "hull-insurance-claim-report-add-confirm",
      });
    },
    async initForm() {
      if ("overview" in this.inputValue) {
        this.inputOverView();
      }
      if ("staff" in this.inputValue) {
        this.inputStaffs();
      }

      if (!this.$refs.ContactInfo.$refs.CompanyName.inputValue) {
        this.$refs.ContactInfo.$refs.CompanyName.inputValue = await this.getUserName();
      }

      if (!this.$refs.PolicyHolder.inputValue) {
        this.$refs.PolicyHolder.inputValue = await this.getUserName();
      }
    },
    async getUserName() {
      const user = await AuthService.getUser();
      return user.name;
    }

  },
  created() {
    this.getVessels();
  },
  beforeMount() {
    if ("staff" in this.inputValue) {
      for (let i = 1;i < this.inputValue.staff.length;i++) {
        this.addContactInfo();
      }
    }
  },
  mounted() {
    this.initForm();

  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";
.right-widget-area {
  padding-left: 20px;
  max-width: 240px;
}

.add-label {
  font-size: 14px;
  font-family: $aisea-font-family;
  font-weight: 600;
  color: $common-text-dark-gray;
}

.free-annotation-text {
  font-size: 14px;
  font-family: $aisea-font-family;
  color: $common-text-dark-gray;
}
</style>
